<template>
  <div class="container mt-4">
    <h2>{{ newsDetail.judul }}</h2>
    
    <img
      :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${newsDetail.image}`"
      alt="news image"
      class="img-fluid rounded mb-3"
    />
    <div v-html="safeContent"></div>
    <small class="text-muted">{{ newsDetail.create_at }}</small>
    <br />
    <!-- <router-link to="/" class="btn btn-primary mt-3">Kembali ke Daftar Berita</router-link> -->
  </div>
</template>

<script>

import axios from "axios";
import DOMPurify from 'dompurify'
export default {
  props: ["id"],
  data() {
    return {
      newsDetail: [],
      loading: true,
      error: null,
    };
  },
  computed: {
    safeContent() {
      return DOMPurify.sanitize(this.newsDetail.isi || '');
    }
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get(`https://mui-kendal.or.id/pengurus/Api/bacaberita/${this.id}`);
        this.newsDetail = response.data[0];
        
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};

</script>
